import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellationapproved',
  templateUrl: './cancellationapproved.component.html',
  styleUrls: ['./cancellationapproved.component.scss']
})
export class CancellationapprovedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
